import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { applyMeta, metaFor } from "@/lib/seo";
import { axonPageView } from "@/lib/axon";
import { gadsPageView, installPhoneClickConversion } from "@/lib/gads";
import { api } from "@/lib/api";

// Personal outreach emails carry one plain URL with ?c=<token>; landing on it counts as the click (no rewritten links in the email).
function reportEmailVisit(search) {
  try {
    const c = new URLSearchParams(search).get("c");
    if (!c || !/^[0-9a-f]{32}$/.test(c) || sessionStorage.getItem(`visit_${c}`)) return;
    sessionStorage.setItem(`visit_${c}`, "1");
    api.post(`/t/v/${c}`).catch(() => {});
  } catch { /* ignore */ }
}

// Per-route <title>, description, canonical and robots tags for the SPA — and the Axon + Google Ads page_view on every route change (Google Ads: public routes only).
export default function RouteMeta() {
  const { pathname, search } = useLocation();
  useEffect(() => { installPhoneClickConversion(); }, []);
  useEffect(() => { applyMeta(metaFor(pathname)); axonPageView(); gadsPageView(pathname, search); reportEmailVisit(search); }, [pathname, search]);
  return null;
}
